import styled, { css } from 'styled-components';

export const CTAContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 85%;
`;

export const CTASVGContainer = styled.div<{ size?: number }>(
  ({ size }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    ${size && `width: ${size}px`};
    ${size && `height: ${size}px`};
  `,
);
